import tns from '@/lib/tiny-slider/tiny-slider.js';

document.addEventListener(
    "DOMContentLoaded", () => {
        const imageCarouselControls = document.querySelectorAll('.control-image-carousel');
        imageCarouselControls.forEach(imageCarouselControl => {
            var carouselElem = imageCarouselControl.querySelector('.image-carousel');

            if (carouselElem.children.length > 1) {
                var iCarousel = tns({
                    container: carouselElem,
                    items: 1,
                    slideBy: 1,
                    autoplay: true,
                    autoplayButtonOutput: false,
                    controls: true,
                    nav: false,
                    speed: 800,
                    controlsContainer: imageCarouselControl.querySelector('.tns-controls'),
                    responsive: {
                        700: {
                            items: 2
                        },
                        1200: {
                            items: 3
                        }
                    }
                });
            }
        });
    }
);
